import orderService from 'services/orderService'
import { CHECKOUT_OUTCOME, mapCheckoutError } from 'utils/checkoutError'

const outcomeForStatus = status => {
  if (status && status.orderStatus === 'F') {
    return CHECKOUT_OUTCOME.PAYMENT_FAILED
  }
  if (status && status.orderStatus === 'T') {
    return CHECKOUT_OUTCOME.CONFIRMED
  }
  return CHECKOUT_OUTCOME.CHECKING
}

// A failed payment response does not establish the final order outcome. Read
// the existing order once; never create another order or retry the payment here.
// Resolves to the customer-facing checkout error and never rejects.
export const resolvePaymentFailure = (payload, error) => {
  const orderNumber = payload.publicOrderNumber
  const original = mapCheckoutError(error, { orderNumber })

  // The status read would fail the same way, so report the expired session.
  if (original.code === 'AUTHENTICATION_REQUIRED') {
    return Promise.resolve(mapCheckoutError(error, { orderNumber, paymentSessionExpired: true }))
  }

  return orderService.getOrderStatus(payload.idOrder)
    .catch(() => undefined)
    .then(status => mapCheckoutError({
      supportReference: original.supportReference,
    }, {
      outcome: outcomeForStatus(status),
      orderNumber,
    }))
}



// WEBPACK FOOTER //
// ./src/utils/paymentFailure.js